import { ADDITEM, REMOVEITEM } from "./actionType";

export const additem = (value) => {
  return {
    type: ADDITEM,
    payload: value,
  };
};

export const removeitem = (value) => {
  return {
    type: REMOVEITEM,
    payload: value,
  };
};
